import ZoomServices from "../../../services/ZoomServices";
import { getValidZoomAccessToken } from "../Auth/ZoomAuthHelper";

const ZoomProvider = {
  async getValidAccessToken() {
    return getValidZoomAccessToken();
  },

  async createMeeting(payload) {
    const token = await this.getValidAccessToken();
    if (!token) throw new Error("Zoom not authenticated");
    
    return ZoomServices.createUserMeeting(payload);
  },

  async updateMeeting(meetingId, payload) {
    const token = await this.getValidAccessToken();
    if (!token) throw new Error("Zoom not authenticated");

    return ZoomServices.updateUserMeeting(meetingId, payload);
  },

  async getUpcomingMeetings() {
    return ZoomServices.getUpcomingMeetings();
  },

  async deleteMeeting(meetingId, token) {
    if (!token) throw new Error("Zoom not authenticated");

    return ZoomServices.deleteMeeting(meetingId, token);
  },

  async deleteExpiredMeetings(token) {
    if (!token) throw new Error("Zoom not authenticated");

    return ZoomServices.deleteExpiredMeetings(token);
  },

  getName() {
    return "Zoom";
  }
};

export default ZoomProvider;
